import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";

export default function UpdateStockForm({
  open,
  onClose,
  onSubmit,
  onReset,
  stocks,
  selectedStocks,
  setSelectedStocks,
  message,
}) {
  const toggleSelection = (stock) => {
    if ((selectedStocks || []).some((s) => s.id === stock.id)) {
      setSelectedStocks(selectedStocks.filter((s) => s.id !== stock.id));
    } else {
      setSelectedStocks([...selectedStocks, stock]);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Eliminar de Stock</DialogTitle>
      <DialogContent>
        {stocks.length === 0 ? (
          <Typography color="textSecondary">
            No hay productos en stock para eliminar.
          </Typography>
        ) : (
          <>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Seleccione uno o más productos para eliminar:
            </Typography>
            <List
              sx={{
                maxHeight: 200,
                overflow: "auto",
                border: "1px solid #ccc",
                mb: 2,
              }}
            >
              {stocks.map((stock) => (
                <ListItemButton
                  key={stock.id}
                  selected={selectedStocks.some((s) => s.id === stock.id)}
                  onClick={() => toggleSelection(stock)}
                  sx={{
                    "&.Mui-selected": {
                      backgroundColor: "rgba(211, 47, 47, 0.25)",
                    },
                    "&.Mui-selected:hover": {
                      backgroundColor: "rgba(211, 47, 47, 0.35)",
                    },
                  }}
                >
                  <ListItemText
                    primary={
                      <>
                        {stock.product_name}{" "} 
                        <span style={{ color: "red" }}>
                          (Cantidad actual: {stock.quantity})
                        </span> 
                      </>
                    }
                  />
                </ListItemButton>
              ))}
            </List>
            
            {message && (
              <Typography color="error" sx={{ mt: 1 }}>
                {message}
              </Typography>
            )}

            <DialogActions sx={{ justifyContent: "space-between", mt: 2 }}>
              <Button onClick={onReset} color="secondary">
                Restablecer
              </Button>
              <Box>
                <Button onClick={onClose} color="primary">
                  Cerrar
                </Button>
                <Button
                  type="submit"
                  color="error"
                  variant="contained"
                  onClick={onSubmit}
                  sx={{ ml: 1 }}
                >
                  Confirmar eliminación
                </Button>
              </Box>
            </DialogActions>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}